const ITEMS = ["Freestyle", "Charme", "Funk 90s", "Hip-Hop", "WebRádio 24h", "Bailes do Rio", "Miami Bass", "Flash House"];

const Marquee = () => (
  <div data-testid="genre-marquee" className="relative border-y border-[#232638] bg-[#0B0C11] py-5 overflow-hidden select-none">
    <div className="flex w-max animate-marquee gap-0">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-2xl sm:text-4xl font-extrabold uppercase tracking-tight text-zinc-700 px-6">
                {item}
              </span>
              <span className="text-amber-400 text-xl">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
